var $ = jQuery.noConflict();
$(document).ready(function() {
    $("#plus").on("click", function() {
        incrementQuantity();
    });
    $("#minus").on("click", function() {
        decrementQuantity();
    });

    function incrementQuantity() {
        var quantityInput = $("#quantity");
        var currentQuantity = parseInt(quantityInput.val());
        quantityInput.val(currentQuantity + 1);
    }

    function decrementQuantity() {
        var quantityInput = $("#quantity");
        var currentQuantity = parseInt(quantityInput.val());
        if (currentQuantity > 1) {
            quantityInput.val(currentQuantity - 1);
        }
    }
});

function setupVerticalCarousel(carouselElement, interval) {
    let currentIndex = 0;
    let intervalId;

    function showSlide(index) {
        const slideHeight = carouselElement.querySelector('.carousel-item').offsetHeight * index;
        carouselElement.style.transform = `translateY(-${slideHeight}px)`;
    }

    function nextSlide() {
        if (currentIndex === carouselElement.childElementCount - 1) {
            currentIndex = 0;
        } else {
            currentIndex++;
        }
        showSlide(currentIndex);
    }

    function prevSlide() {
        if (currentIndex === 0) {
            currentIndex = carouselElement.childElementCount - 1;
        } else {
            currentIndex--;
        }
        showSlide(currentIndex);
    }

    function startCarousel() {
        intervalId = setInterval(nextSlide, interval);
    }

    function pauseCarousel() {
        clearInterval(intervalId);
    }

    function resumeCarousel() {
        startCarousel();
    }

    function resetCarousel() {
        pauseCarousel();
        startCarousel();
    }
    carouselElement.addEventListener('mouseenter', pauseCarousel);
    carouselElement.addEventListener('mouseleave', resumeCarousel);
    startCarousel();
    return {
        nextSlide,
        prevSlide
    };
}
class IntersectionObserverHandler {
    constructor(targetElement, elementsToAnimate, animationClasses, options) {
        this.targetElement = targetElement;
        this.elementsToAnimate = elementsToAnimate;
        this.animationClasses = animationClasses;
        this.options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        };
        this.init();
    }
    init() {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.options);
        this.observer.observe(this.targetElement);
    }
    handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.elementsToAnimate.forEach((element, index) => {
                    if (this.animationClasses[index]) {
                        if (!element.classList.contains(this.animationClasses[index])) {
                            element.classList.add(this.animationClasses[index]);
                        }
                    }
                });
            } else {}
        });
    }
}
class IntersectionObserver2Handler {
    constructor(targetElement, clickElement = {}) {
        this.targetElement = targetElement;
        this.clickElement = clickElement;
        this.options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        };
        this.init();
    }
    init() {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.options);
        this.observer.observe(this.targetElement);
    }
    handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (this.clickElement) {
                    const otherClickElements = document.querySelectorAll('.product-navigation-bar .nav-link');
                    otherClickElements.forEach(element => {
                        if (element !== this.clickElement && element.classList.contains('active')) {
                            element.classList.remove('active');
                        }
                    });
                    this.clickElement.forEach(element => {
                        element.classList.add('active');
                    });
                }
            } else {}
        });
    }
}

function goToTarget(event) {
    const value = event.getAttribute('aria-controls');
    const elements = document.querySelectorAll(`[data-jump-tab="${value}"]`);
    console.log('new')
    if (elements.length > 0) {
        const offset = 200;
        const elementRect = elements[0].getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementRect - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });

    }
}
class AnimateValueIntersectionObserverHandler {
    constructor(targetElement, elementsToAnimate, start, end, duration) {
        this.targetElement = targetElement;
        this.elementsToAnimate = elementsToAnimate;
        this.start = start;
        this.end = end;
        this.duration = duration;
        this.options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        };
        this.init();
    }
    init() {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.options);
        this.observer.observe(this.targetElement);
    }
    handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.elementsToAnimate.forEach((element) => {
                    this.animateValueFunction(element, this.start, this.end, this.duration);
                });
            }
        });
    }
    animateValueFunction(obj, start, end, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            obj.innerHTML = " " + Math.floor(progress * (end - start) + start) + " riders";
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }
}
class AnimateValueIntersectionObserverHandler2 {
    constructor(targetElement, elementsToAnimate) {
        this.targetElement = targetElement;
        this.elementsToAnimate = elementsToAnimate;
        this.options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        };
        this.init();
    }
    init() {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.options);
        this.observer.observe(this.targetElement);
    }
    handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.elementsToAnimate.forEach((element) => {
                    const start = parseInt(element.dataset.start);
                    const end = parseInt(element.dataset.end);
                    const duration = parseInt(element.dataset.duration);
                    const text = element.dataset.text;
                    this.animateValueFunction(element, start, end, duration, text);
                });
            }
        });
    }
    animateValueFunction(obj, start, end, duration, text) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            obj.innerHTML = Math.floor(progress * (end - start) + start);
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
            obj.append(text);
        };
        window.requestAnimationFrame(step);
    }
}
document.addEventListener('DOMContentLoaded', function() {
    const elementsToAnimateCon = document.querySelectorAll('.hb-animate-con');
    elementsToAnimateCon.forEach(element => {
        const childrenToAnimate = element.querySelectorAll('.hb-animate-me');
        const elementsArray = [];
        const animationTypesArray = [];
        childrenToAnimate.forEach(child => {
            const animationType = child.dataset.animationtype;
            elementsArray.push(child);
            animationTypesArray.push(animationType);
        });
        const observerHandler = new IntersectionObserverHandler(element, Array.from(childrenToAnimate), animationTypesArray);
    });
    const jump_elements = document.querySelectorAll('[data-jump-tab]');
    jump_elements.forEach(jump_ind => {
        const ind_value = jump_ind.getAttribute('data-jump-tab');
        const tab_ind = document.querySelectorAll(`.product-navigation-bar[data-bs-target="#${ind_value}"]`);
        if (tab_ind) {
            const observerHandler = new IntersectionObserver2Handler(jump_ind, tab_ind);
        }
    });
});
class ImageSlider {
    constructor(containerSelector, scrollDistance, visibleWidth, leftArrowSelector, rightArrowSelector) {
        this.imgContainer = document.querySelector(containerSelector);
        this.arrowLeft = document.querySelector(leftArrowSelector);
        this.arrowRight = document.querySelector(rightArrowSelector);
        this.scrollDistance = scrollDistance || 444;
        this.visibleWidth = visibleWidth || this.imgContainer.offsetWidth;
        this.scrollLeft = this.scrollLeft.bind(this);
        this.scrollRight = this.scrollRight.bind(this);
        this.addEventListeners();
    }
    scrollLeft() {
        this.imgContainer.scrollBy(-this.scrollDistance, 0);
    }
    scrollRight() {
        this.imgContainer.scrollBy(this.scrollDistance, 0);
        if (this.imgContainer.offsetWidth + this.imgContainer.scrollLeft >= this.imgContainer.scrollWidth) {
            this.imgContainer.scrollBy(-this.imgContainer.scrollWidth, 0);
        }
    }
    addEventListeners() {
        if (this.arrowLeft && this.arrowRight) {
            this.arrowLeft.addEventListener("click", this.scrollLeft);
            this.arrowRight.addEventListener("click", this.scrollRight);
        } else {
            console.error("Arrows not found.");
        }
    }
}
document.addEventListener("DOMContentLoaded", function() {
    var toggleButton = document.querySelector(".select-selected");
    var sortDropdown = document.getElementById("sort-by");
    var selectedItem = document.querySelector('.opt-name.same-as-selected');
    if (selectedItem) {
        var dataName = selectedItem.getAttribute("data-name");
        if (dataName !== null) {
            toggleButton.innerHTML = dataName;
        }
    }
    var targetDiv = document.querySelector(".select-items");
    if (toggleButton) {
        toggleButton.addEventListener("click", function() {
            if (targetDiv.style.display === "none") {
                targetDiv.style.display = "block";
            } else {
                targetDiv.style.display = "none";
            }
        });
    }
    if (targetDiv) {
        opt_el = targetDiv.querySelectorAll('.opt-name');
        opt_el.forEach(function(item) {
            item.addEventListener("click", function() {
                var dataValue = item.dataset.value;
                var dataName = item.dataset.name;
                if (dataValue !== undefined) {
                    toggleButton.innerHTML = dataName;
                    sortDropdown.value = dataValue;
                    sortDropdown.dispatchEvent(new Event('change'));
                } else {}
                targetDiv.style.display = "none";
            })
        })
    }
});

function initializeTabNavigation(tabSelector, nextButtonId, prevButtonId) {
    const tabs = document.querySelectorAll(tabSelector);
    let currentIndex = 0;
    document.getElementById(nextButtonId).addEventListener('click', function() {
        showSmTab(currentIndex + 1);
    });
    document.getElementById(prevButtonId).addEventListener('click', function() {
        showSmTab(currentIndex - 1);
    });

    function showSmTab(index) {
        tabs[currentIndex].classList.remove('active');
        document.querySelector(tabs[currentIndex].getAttribute('href')).classList.remove('active', 'show');
        currentIndex = (index + tabs.length) % tabs.length;
        tabs[currentIndex].classList.add('active');
        document.querySelector(tabs[currentIndex].getAttribute('href')).classList.add('active', 'show');
    }
}

function getFocusableElements(container) {
    return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first)
            return;
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    elementToFocus.focus();
}
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });
    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });
    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
        if (mouseClick) return;
        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
    }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {
            bubbles: true
        })
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`
        }
    };
}
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}
Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};
Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};
Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },
    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },
    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);
        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }
            this.provinceContainer.style.display = "";
        }
    },
    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },
    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};
class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }
    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }
    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }
    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const button = this.querySelector('button');
        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}
customElements.define('modal-opener', ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }
    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
        }
    }
}
customElements.define('deferred-media', DeferredMedia);
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            fetch(this.dataset.url).then(response => response.text()).then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                }
                if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                    this.remove();
                }
                if (html.querySelector('.grid__item')) {
                    this.classList.add('product-recommendations--loaded');
                }
            }).catch(e => {
                console.error(e);
            });
        }
        new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '0px 0px 400px 0px'
        }).observe(this);
    }
}
customElements.define('product-recommendations', ProductRecommendations);


const handleIntersection_cp = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);
    const checkboxes = document.querySelectorAll('.product-checkbox');
    const addToCartButton = document.getElementById('addToCartButton');

    const url = productRecommendationsSection.dataset.url;


    fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }

        })
        .catch(e => {
            console.error(e);
        });
};
const productRecommendationsSection = document.querySelector('.product-recommendations');

if (document.querySelector('.product-recommendations')) {
    const observer = new IntersectionObserver(handleIntersection_cp, {
        rootMargin: '0px 0px 200px 0px'
    });

    observer.observe(productRecommendationsSection);
}

$('.addToCartButton').click(function() {
    alert(this.getTotalItemCount());
});